/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/17/20
 *
 */

export const SubscriptionStatusPaddle = Object.freeze({
	PENDING: "pending", //high risk transaction - waiting for payment confirmation
	ACCEPTED: "accepted", //high risk transaction accepted - status needs to be changed to "active"
	REJECTED: "rejected", //high risk transaction rejected

	ACTIVE: "active",//	Indicates an active subscription, payments are up-to-date. You should give the user full access to their chosen plan.
	TRIALING: "trialing",//	Indicates the user is in a ‘trial’ state. Dependant on how you’re using trials, you should treat the user differently. The state will change to active once the users first recurring payment is successfully completed.
	PAST_DUE: "past_due",//	Indicates we have tried a payment for this user and it has failed, we are retrying the payment according to your retry rules. After a few more payment attempts this will either change to active or deleted dependant on your preferences. You should decide how your wish to treat users in this state.
	CANCELLED: "deleted",//	Indicates that this subscription has been cancelled. You should treat this user as ‘cancelled’ unless they re-subscribe.
	PAUSED: "paused",//	Indicates that this subscription has been paused. We treat this user as ‘cancelled’ unless they re-subscribe.


	//Non paddle statuses.
	FREE: "free", //Indicates user is on a freemium plan
	TRIALING_NO_CC: "trialing_no_cc", //Indicates user is in trial state but no credit card is provided
	CANCEL_PENDING: "delete_pending", //Indicates cancellation is pending while outstanding usage is being billed.
	CHARGE_PENDING: "charge_pending", //Indicates outstanding usage should be charged on next payment.

})
